<template>
  <div>
    <b-modal
      size="xl"
      id="modalMessages"
      centered
      hide-header
      hide-footer
      dialog-class="mm-dialog"
      content-class="mm-content"
      body-class="mm-modal-body"
    >
      <div class="mm-wrapper">
        <!-- Body com scroll -->
        <div class="mm-body">
          <div class="modal-content-wrapper">
            <div class="rowContainer">
              <span>
                <b-icon-card-checklist></b-icon-card-checklist> Nova Mensagem
              </span>
              <div class="rowContent">
                <div class="field">
                  <label v-if="isMobile" class="field-label">Tipo</label>
                  <InputSelect
                    :style="isMobile ? 'width: 100% !important' : 'width: 20% !important'"
                    :label="isMobile ? '' : 'Tipo'"
                    :labelFixed="!isMobile"
                    valueField="value"
                    textField="text"
                    :items="messageTypes"
                    :dataSelect.sync="payloadMessage.tipo"
                    :dataInput="payloadMessage.tipo"
                    :enableIconCreate="false"
                    ref="tipo"
                  />
                </div>

                <div class="field">
                  <label v-if="isMobile" class="field-label">Título</label>
                  <Input
                    :label="isMobile ? '' : 'Título'"
                    :labelFixed="!isMobile"
                    :style="isMobile ? 'width: 100% !important' : 'width: 20% !important'"
                    type="text"
                    :dataInput.sync="payloadMessage.titulo"
                    placeholder="Informe um título"
                    ref="titulo"
                  />
                </div>

                <div class="field">
                  <label v-if="isMobile" class="field-label">Descrição</label>
                  <Input
                    :label="isMobile ? '' : 'Descrição'"
                    :labelFixed="!isMobile"
                    :style="isMobile ? 'width: 100% !important' : 'width: 80% !important'"
                    type="text"
                    :dataInput.sync="payloadMessage.texto"
                    ref="texto"
                  />
                </div>
              </div>
            </div>

            <span class="titleNcm">Mensagens cadastradas</span>

            <!-- Tabela Desktop -->
            <div v-if="!isMobile" class="ContentTable">
              <table>
                <thead class="headTable">
                  <tr style="width: 100%">
                    <th style="font-size: 14px; font-weight: 600">Tipo</th>
                    <th style="font-size: 14px; font-weight: 600">Título</th>
                    <th style="width: 80%; font-size: 14px; font-weight: 600">
                      Descrição
                    </th>
                    <th
                      style="
                        text-align: center;
                        font-size: 14px;
                        font-weight: 600;
                        padding: 0 10px;
                      "
                    >
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="message in allMessages" :key="message.id">
                    <td style="text-align: center; font-size: 13px">
                      {{ message.tipo === "geral" ? "Geral" : "MIP" }}
                    </td>

                    <td style="text-align: center; font-size: 13px">
                      {{ message.titulo }}
                    </td>

                    <td style="width: 80%; text-align: center; font-size: 13px">
                      {{ message.texto }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding: 0 !important;
                        display: flex;
                        height: 100%;
                        justify-content: center;
                        gap: 20px;
                        padding: 0.5rem;
                      "
                    >
                      <b-icon-pencil
                        @click="findById(message.id)"
                        scale="1"
                        role="button"
                      />

                      <b-icon-x-circle
                        @click="deleteMessage(message.id)"
                        role="button"
                        style="color: red"
                        scale="1"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Cards Mobile -->
            <div v-else class="messages-cards">
              <div
                v-for="message in allMessages"
                :key="message.id"
                class="message-card"
              >
                <div class="card-header">
                  <span
                    class="badge-tipo"
                    :class="message.tipo === 'geral' ? 'badge-geral' : 'badge-mip'"
                  >
                    {{ message.tipo === "geral" ? "Geral" : "MIP" }}
                  </span>
                  <h4 class="card-title">{{ message.titulo }}</h4>
                </div>
                <p class="card-description">{{ message.texto }}</p>
                <div class="card-actions">
                  <button
                    class="btn-action btn-edit"
                    @click="findById(message.id)"
                  >
                    <b-icon-pencil scale="1" /> Editar
                  </button>
                  <button
                    class="btn-action btn-delete"
                    @click="deleteMessage(message.id)"
                  >
                    <b-icon-x-circle scale="1" /> Excluir
                  </button>
                </div>
              </div>

              <div v-if="allMessages.length === 0" class="empty-state">
                <b-icon-inbox scale="2" style="color: #9ca3af" />
                <p>Nenhuma mensagem cadastrada</p>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer fixo -->
        <div class="mm-footer">
          <div class="footer-buttons">
            <button
              class="btnsModal btnClose"
              @click="handleCloseModalAndClear"
            >
              Fechar
            </button>
            <button class="btnsModal btnSave" @click="saveOrUpdate">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import ServiceMessages from "../../services/serviceMessages";
import Input from "../UI/CustomInputs/Input.vue";
import InputSelect from "../UI/CustomInputs/InputSelect.vue";

export default {
  props: {
    defaultMessage: {
      type: String,
      default: "geral",
    },
  },
  data() {
    return {
      payloadMessage: {
        id: "",
        descricao: "",
        titulo: "",
        tipo: this.defaultMessage,
      },
      allMessages: [],
      messageTypes: [
        { text: "MIP", value: "mip" },
        { text: "Geral", value: "geral" },
      ],
    };
  },
  components: {
    Input,
    InputSelect,
  },
  computed: {
    isMobile() {
      return window.matchMedia("(max-width: 764px)").matches;
    },
  },
  methods: {
    async save() {
      try {
        await ServiceMessages.save(this.payloadMessage);
        this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "Salvo com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            `${error.response.data.message || error.response.data.erros}` ||
            "Ocorreu um erro o salvar!",
          type: "info",
        });
      }
    },

    async update() {
      try {
        await ServiceMessages.update(this.payloadMessage);
        this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "Atualizado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            `${error.response.data.message || error.response.data.erros}` ||
            "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async deleteMessage(id) {
      try {
        await ServiceMessages.delete(id);
        await this.getAllMessages();

        this.$emit("getNewMessage");

        return this.$toast.open({
          message: "deletado com sucesso!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message || "Ocorreu um problema ao deletar!",
          type: "info",
        });
      }
    },

    async findById(id) {
      const result = await ServiceMessages.findById(id);

      Object.assign(this.payloadMessage, result);

      this.$refs.tipo.valueItems = result.tipo;
      this.$refs.texto.valueInput = result.texto;
      this.$refs.titulo.valueInput = result.titulo;
    },

    async getAllMessages() {
      const result = await ServiceMessages.fillComobobox();
      this.allMessages = result;
    },

    async saveOrUpdate() {
      this.payloadMessage.id === "" ? await this.save() : await this.update();

      this.clear();
    },

    clear() {
      this.payloadMessage.id = "";
      this.payloadMessage.tipo = this.defaultMessage;
      this.payloadMessage.titulo = "";
      this.payloadMessage.texto = "";

      this.$refs.tipo.valueItems = this.defaultMessage;
      this.$refs.titulo.valueInput = "";
      this.$refs.texto.valueInput = "";
    },

    handleCloseModalAndClear() {
      this.clear();
      this.$bvModal.hide("modalMessages");
    },
  },
  mounted() {
    this.getAllMessages();
  },
  watch: {
    defaultMessage() {
      this.payloadMessage.tipo = this.defaultMessage;
    },
  },
};
</script>

<style scoped>
.styleHoverDelete:hover {
  background-color: #ff6347;
  border: solid 1px black;
}

.tabsContentSearch {
  overflow-y: scroll;
  max-height: 300px;
}

.modal-content-wrapper {
  padding: 1rem;
}

.footer-buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.btnsModal {
  border-radius: 8px;
  background-color: #006256;
  width: 165px;
  height: 40px;
  border: none;
  color: white;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btnsModal:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}

.btnsModal:active {
  transform: scale(0.98);
}

.btnClose {
  background-color: #6b7280;
}

.btnSave {
  background-color: #10b981;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  justify-content: space-between;
  gap: 10px;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #f9fafb;
  margin-bottom: 16px;
}

.rowContainer span {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ContentTable {
  display: flex;
  flex-direction: column;
  height: 50vh;
  max-height: 50vh;
  overflow: auto;
  width: 100%;
  max-width: 100%;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.titleNcm {
  margin-top: 24px;
  margin-bottom: 12px;
  width: 100%;
  display: flex;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  justify-content: flex-start;
}

tr:nth-child(even) {
  background: #f9fafb;
}

.headTable {
  color: whitesmoke;
  background: #374151;
  text-align: center;
  height: 40px;
}

.titleCard {
  margin-bottom: 32px !important;
  font-weight: 600;
  color: #666360;
  font-size: 16px;
}

/* Mobile Cards */
.messages-cards {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

.message-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.card-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.badge-tipo {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-geral {
  background: #dbeafe;
  color: #1e40af;
}

.badge-mip {
  background: #fef3c7;
  color: #92400e;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  margin: 0;
  flex: 1;
}

.card-description {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
  margin: 0 0 12px 0;
  word-break: break-word;
}

.card-actions {
  display: flex;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
}

.btn-action {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-edit {
  background: #dbeafe;
  color: #1e40af;
}

.btn-edit:active {
  background: #bfdbfe;
}

.btn-delete {
  background: #fee2e2;
  color: #991b1b;
}

.btn-delete:active {
  background: #fecaca;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
}

.empty-state p {
  margin-top: 12px;
  font-size: 14px;
}

/* Field container */
.field {
  width: 100%;
}

.field-label {
  display: none;
}

/* Modal structure */
.mm-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.mm-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.mm-footer {
  border-top: 1px solid #e5e7eb;
  background: white;
  padding: 12px 16px;
}

/* Mobile Responsive */
@media (max-width: 764px) {
  /* Garantir que o overlay não crie scroll */
  ::v-deep .mm-dialog {
    margin: 0.75rem !important;
    height: auto !important;
    max-width: calc(100vw - 1.5rem) !important;
  }

  /* O container do modal NUNCA pode rolar */
  ::v-deep .mm-content {
    height: 90vh !important;
    max-height: 90vh !important;
    overflow: hidden !important;
    display: flex !important;
    flex-direction: column !important;
    border-radius: 16px !important;
  }

  /* BootstrapVue injeta .modal-body - aqui que costuma ficar o overflow */
  ::v-deep .mm-modal-body {
    overflow: hidden !important;
    padding: 0 !important;
    flex: 1 1 auto !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;
  }

  .mm-wrapper {
    height: 100% !important;
    display: flex !important;
    flex-direction: column !important;
    min-height: 0 !important;
  }

  /* Único local com scroll */
  .mm-body {
    flex: 1 1 auto !important;
    overflow-y: auto !important;
    -webkit-overflow-scrolling: touch;
    min-height: 0 !important;
    padding: 12px !important;
  }

  .mm-footer {
    flex: 0 0 auto !important;
    padding: 12px !important;
    background: #fff !important;
    border-top: 1px solid #e5e7eb !important;
  }

  /* Garantia: nenhum outro container pode rolar */
  .mm-body * {
    overscroll-behavior: contain;
  }

  /* Form coluna */
  .rowContent {
    flex-direction: column;
    gap: 12px;
  }

  .rowContainer {
    padding: 12px;
  }

  /* Field stacked labels */
  .field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 0;
  }

  .field-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    margin-bottom: 4px;
  }

  /* Desativar floating labels internos dos componentes */
  ::v-deep .input-group {
    position: relative;
  }

  ::v-deep .user-label,
  ::v-deep .fixedSelect2 {
    display: none !important;
  }

  ::v-deep .input,
  ::v-deep .borderInput,
  ::v-deep input.input,
  ::v-deep .form-control,
  ::v-deep .custom-select,
  ::v-deep select {
    min-height: 44px !important;
    font-size: 16px !important;
    padding: 10px 12px !important;
    border-radius: 8px;
  }

  /* Footer botões */
  .footer-buttons {
    flex-direction: row;
  }

  .btnsModal {
    width: 100%;
    height: 48px;
    font-size: 16px;
    border-radius: 12px;
  }

  /* Cards */
  .messages-cards {
    max-height: none;
    overflow: visible;
  }

  .message-card {
    padding: 12px;
  }

  /* Remover scroll da tabela no mobile */
  .ContentTable {
    overflow: visible !important;
    max-height: none !important;
    height: auto !important;
  }

  .card-title {
    font-size: 15px;
  }

  .card-description {
    font-size: 13px;
  }

  .titleNcm {
    margin-top: 16px;
    margin-bottom: 8px;
    font-size: 13px;
  }
}
</style>